/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts
// Build from env v64.0.6-rc.0
// File ./data/openapi.yaml
// Build 34223116943
// Artifact https://api.github.com/repos/Konova-AG/emi-api/actions/artifacts/10054703741/zip
// Built at 2026-09-22T09:19:11.348Z

import { createClientConfig } from '../axios-setup.ts';

import { type ClientOptions, type Config, createClient, createConfig } from './client';
import type { ClientOptions as ClientOptions2 } from './types.gen';

/**
 * The `createClientConfig()` function will be called on client initialization
 * and the returned object will become the client's initial configuration.
 *
 * You may want to initialize your client this way instead of calling
 * `setConfig()`. This is useful for example if you're using Next.js
 * to ensure your client always has the correct values.
 */
export type CreateClientConfig<T extends ClientOptions = ClientOptions2> = (override?: Config<ClientOptions & T>) => Config<Required<ClientOptions> & T>;

export const client = createClient(createClientConfig(createConfig<ClientOptions2>({ baseURL: 'http://api.emi.tld' })));
